import template from './building-type.jade';
import allItems, { itemsByCategory } from '../../../enums/building-type';
import { filterItems } from '../../filter-items';
import { firstLetterToUpperCase } from '@cian/ui/app/services/utils';
import validation from '../../../services/validation';

const config = {
    building: {
        title: 'Возможное назначение',
        required: true,
        validationMessages: {
            required: 'Укажите назначение'
        },
        excludedItems: [
            'businessQuarter2',
            'businessHouse',
            'tradingHouse'
        ]
    },
    default: {
        title: 'Тип здания',
        required: false
    }
};

export default angular
    .module('cian.addForm.buildingType', ['cian.addForm.fieldTypeDropdown'])
    .directive('cianAfAboutBuildingBuildingType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'categoryService', 'adStateService', '$timeout', 'deviceService', function ($scope, categoryService, adStateService, $timeout, deviceService) {
            this.ad.building = this.ad.building || {};
            this.isInitialized = false;
            this.isMobile = deviceService.isMobile;

            $scope.$watch(() => this.ad.category, category => {
                if (!category) return;
                const { objectType } = categoryService.getInfoByCategory(category);
                this.config = config[objectType] || config.default;

                let rawItems = itemsByCategory.commercial.items;
                if (objectType === 'building') {
                    rawItems = rawItems.filter((item) => {
                        return config.building.excludedItems.indexOf(item) === -1
                    });
                }

                this.items = filterItems(allItems, 'value', rawItems)
                    .map(i => ({ id: i.value, name: i.text }));

                this.isInitialized = true;

                $timeout(() => {
                    this.validation = validation(this.form, 'building.type', (key) => {
                        if (this.config && this.config.validationMessages && this.config.validationMessages[key]) {
                            return this.config.validationMessages[key]
                        }
                    });
                }, 0);
            });
        }],
        controllerAs: 'buildingType',
        template,
    }))
    .name;
